import React from "react";
import "./style/ContextMenu.css";

const ContextMenu = ({ xPos, yPos, editComment, deleteHighlight, is_view }) => {
  return (
    <div className="context-menu" style={{ top: yPos + 2, left: xPos + 2 }}>
      {is_view === false && (
        <>
          <button onClick={editComment}>Edit</button>
          <button onClick={deleteHighlight}>Delete</button>
        </>
      )}
    </div>
  );
};

export default ContextMenu;
